var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/search.tsx";
import classNames from 'classnames';
import debounce from 'lodash/debounce';
import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { changeSearch, clearSearch, setSearchAccount, showSearch, submitSearch } from 'soapbox/actions/search';
import AutosuggestAccountInput from 'soapbox/components/autosuggest_account_input';
import SvgIcon from 'soapbox/components/ui/icon/svg-icon';
import { useAppSelector } from 'soapbox/hooks';
const messages = defineMessages({
  placeholder: {
    "id": "search.placeholder",
    "defaultMessage": "Search"
  },
  action: {
    "id": "search.action",
    "defaultMessage": "Search for \u201C{query}\u201D"
  }
});
function redirectToAccount(accountId, routerHistory) {
  return (_dispatch, getState) => {
    const acct = getState().getIn(['accounts', accountId, 'acct']);
    if (acct && routerHistory) {
      routerHistory.push(`/@${acct}`);
    }
  };
}
const Search = props => {
  const {
    autoFocus = false,
    autoSubmit = false,
    autosuggest = false,
    openInRoute = false
  } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const intl = useIntl();
  const value = useAppSelector(state => state.search.value);
  const submitted = useAppSelector(state => state.search.submitted);
  const debouncedSubmit = useCallback(debounce(() => {
    dispatch(submitSearch());
  }, 900), []);
  const handleChange = event => {
    const {
      value
    } = event.target;
    dispatch(changeSearch(value));
    if (autoSubmit) {
      debouncedSubmit();
    }
  };
  const handleClear = event => {
    event.preventDefault();
    if (value.length > 0 || submitted) {
      dispatch(clearSearch());
    }
  };
  const handleSubmit = () => {
    if (openInRoute) {
      dispatch(setSearchAccount(null));
      dispatch(submitSearch());
      history.push('/search');
    } else {
      dispatch(submitSearch());
    }
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit();
    } else if (event.key === 'Escape') {
      document.querySelector('.ui')?.parentElement?.focus();
    }
  };
  const handleFocus = () => {
    dispatch(showSearch());
  };
  const handleSelected = accountId => {
    dispatch(clearSearch());
    dispatch(redirectToAccount(accountId, history));
  };
  const makeMenu = () => [{
    text: intl.formatMessage(messages.action, {
      query: value
    }),
    icon: require('@tabler/icons/search.svg'),
    action: handleSubmit
  }];
  const hasValue = value.length > 0 || submitted;
  const Component = autosuggest ? AutosuggestAccountInput : 'input';
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "search",
    className: "sr-only",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.placeholder)), /*#__PURE__*/React.createElement("div", {
    className: "relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Component, {
    className: "block w-full pl-3 pr-10 py-2 border border-gray-100 dark:border-slate-600 rounded-full leading-5 bg-gray-100 dark:text-white placeholder-gray-500 dark:placeholder-gray-300 dark:bg-slate-900 focus:bg-white focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
    type: "text",
    id: "search",
    placeholder: intl.formatMessage(messages.placeholder),
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onSelected: handleSelected,
    autoFocus: autoFocus,
    autoSelect: false,
    menu: makeMenu(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: "absolute inset-y-0 right-0 px-3 flex items-center cursor-pointer",
    onClick: handleClear,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SvgIcon, {
    src: require('@tabler/icons/search.svg'),
    className: classNames('h-4 w-4 text-gray-400', {
      hidden: hasValue
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(SvgIcon, {
    src: require('@tabler/icons/x.svg'),
    className: classNames('h-4 w-4 text-gray-400', {
      hidden: !hasValue
    }),
    "aria-label": intl.formatMessage(messages.placeholder),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 11
    }
  }))));
};
export default Search;